import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'notes',
    component: () =>
      import(/* webpackChunkName: "notes" */ '@/views/Notes.vue'),
    meta: { requiresLoggedIn: true }
  },
  {
    path: '/note/:guid',
    name: 'note',
    component: () => import(/* webpackChunkName: "note" */ '@/views/Note.vue'),
    props: route => ({ guid: route.params.guid }), //usn=UpdateSequenceNum
    meta: { requiresLoggedIn: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Terms.vue')
  },
  {
    path: '/callback',
    name: 'callback',
    component: () =>
      import(/* webpackChunkName: "callback" */ '@/views/Callback.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
